import moment from 'moment';
import { IntlShape } from 'react-intl';
import { dateISOtoDDMMMYYYY } from './date';
import { parseURL } from './url';
import supportedLanguages from './supportedLanguages';

export const localizePathname = (pathname: any, locale: any): string => {
  const pathnameArray = pathname.split('/');
  if (Object.keys(supportedLanguages).includes(pathnameArray[1])) {
    pathnameArray[1] = locale;
  } else {
    pathnameArray.splice(1, 0, locale);
  }
  return pathnameArray.join('/');
};

// TODO: Clean up these date and number functions, react-intl should be handling a lot of it out of the box
export const renderDates = ({ start, end = null }: any, locale = moment.locale()) => {
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
  const startDate = dateISOtoDDMMMYYYY(start, locale);
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 2.
  const endDate = end && dateISOtoDDMMMYYYY(end, locale);
  return endDate ? `${startDate} to ${endDate}` : startDate;
};

export const renderAmountWithSymbol = (amount: any, currency: any, locale = null) =>
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
  }).format(amount);

export const localizeURL = (url: any, locale: any) => {
  const { origin, pathname, search, hash } = parseURL(url);
  const localizedPathname = localizePathname(pathname, locale);
  const localizedURL = `${origin || ''}${localizedPathname}${search}${hash}`;
  return localizedURL;
};

export const localizeLocation = (location: any, locale: any) => {
  const { pathname, state } = location;

  if (state && state.referrer) {
    state.referrer.pathname = localizePathname(state.referrer.pathname, locale);
  }

  return {
    ...location,
    pathname: localizePathname(pathname, locale),
    state,
  };
};

// TODO: put params into an option object and refactor usages
export const formatCurrency = (
  formatNumber: IntlShape['formatNumber'],
  value: any,
  currency: any,
  trimCents = false,
) => {
  if (!value) return value;
  const formattedValue = formatNumber(value, { style: 'currency', currency });
  if (trimCents && formattedValue.endsWith('.00')) {
    return formattedValue.substring(0, formattedValue.indexOf('.00'));
  }
  return formattedValue;
};
